import ErrorBoundary from '~/components/experimental/ErrorBoundary/ErrorBoundary'
import { loadComponent } from '~/utils/loaders/halvesLoader'

interface contentData {
  sys: {
    contentTypeId: string
  }
}

interface ComponentRendererProps {
  components: contentData
  layoutColour: string
  layoutPosition?: number
  avantGarde?: boolean
}

export function ComponentRenderer({
  components,
  layoutColour,
  layoutPosition = 0,
  avantGarde = false
}: ComponentRendererProps) {
  const Component = loadComponent(components?.sys?.contentTypeId, avantGarde)

  return (
    <ErrorBoundary message={components?.sys?.contentTypeId}>
      <Component
        content={components}
        layoutColour={layoutColour}
        avantGarde={avantGarde}
        layoutStyle='halves'
        layoutPosition={layoutPosition}
      />
    </ErrorBoundary>
  )
}
